import { createContext } from 'react';

import type { FilterValue, TablePaginationConfig } from 'antd/es/table/interface';

import type { IParticipant, IParticipantsStat } from '@/api/endpoints/schools/schoolParticipants';

type TContext = {
  filters: Record<string, FilterValue | null>;
  setFilters: (filters: Record<string, FilterValue | null>) => void;
  pagination: TablePaginationConfig | undefined;
  setPagination: (pagination: TablePaginationConfig) => void;
  participantsTableData: IParticipant[];
  setParticipantsTableData: (data: IParticipant[]) => void;
  searchValue: string;
  participantsStat: IParticipantsStat;
};

export const ParticipantsContext = createContext<TContext>({} as TContext);
